export default "__VITE_ASSET__46b1cb6a__"